export default __webpack_public_path__ + "static/media/avo_caprese.11dbc309.jpg";